import NDRIcon from "@assets/ndr2025/ndr-title-icon.gif";
import { NDR_2025_PAGE } from "@config/ndr2025";
import Heading from "@elements/Typography/Heading";
import { getGTMData, getMetaData } from "@helper/getMetaData";
import BHBasePage, { type BHBasePageProps } from "@routes/BHBasePage";
import ErrorPage from "@routes/ErrorPage";
import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import NotFound from "@routes/NotFound";
import type { TRouteWithoutRedirect } from "@sphtech/web2-core/ssr";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";
import { useLoaderData } from "react-router";

import LiveBlog from "./Components/LiveBlog";
import SeasonalKeywordArticleList from "./Components/SeasonalKeywordArticleList";
import {
  fetchSeasonalTagData,
  GEPayloadResponseType,
} from "./SeasonalTags.server";
import SeasonalTagsMetaData from "./SeasonalTagsMetaData";

const adsSectionName = NDR_2025_PAGE;
export function meta() {
  return [getMetaData(SeasonalTagsMetaData(adsSectionName).metaTags)];
}

export default function SeasonalTags() {
  const dataLoaderResponse: TRouteWithoutRedirect<
    GEPayloadResponseType,
    string
  > = useLoaderData();

  if (dataLoaderResponse.type === ResponseType.CLIENT_ERROR) {
    return <NotFound />;
  } else if (dataLoaderResponse.type === ResponseType.SERVER_ERROR) {
    return <ErrorPage message="Something went wrong" />;
  }

  const { tagsData, geLiveBlog } = dataLoaderResponse.payload;
  const pageAdTargetValue = PageAdTargetingTypeEnum.LISTING;

  const basePageProps: BHBasePageProps = {
    uniqueSectionName: adsSectionName,
    pageAdTargetValue: pageAdTargetValue,
    hasLb1Ads: true,
    showNDRBanner: false,
    bodyWrapperStyle: "my-0 lg:my-0 py-3 lg:py-md",
  };

  return (
    <BHBasePage {...basePageProps}>
      <WidgetWrapper>
        <div>
          <div className="border-b-[1px] border-grey-400 pb-[10px] md:pb-[20px] mb-[10px] md:mb-[20px]">
            <div className="flex gap-xs">
              <img
                src={NDRIcon}
                alt="NDR-icon"
                className="md:w-12 md:h-12 w-8 h-8"
              />
              <Heading
                className="text-[#F62455] text-[18px] md:text-[30px] font-semibold font-secondary"
                Element="h1"
              >
                Hari Kebangsaan 2025
              </Heading>
            </div>
          </div>
        </div>
        <div className="flex gap-[40px]">
          <div
            className={`w-full flex flex-col gap-5 ${geLiveBlog ? "lg:w-[992px] xl:w-[847px]" : ""}`}
          >
            {geLiveBlog && (
              <div className="xl:hidden mx-[10px] lg:mx-0">
                <LiveBlog variant="body" seasonalLiveBlogContent={geLiveBlog} />
              </div>
            )}
            <SeasonalKeywordArticleList
              articles={tagsData}
              adsSectionName={adsSectionName}
            />
          </div>
          {geLiveBlog && (
            <div className="hidden xl:block">
              <LiveBlog
                variant="sidebar"
                seasonalLiveBlogContent={geLiveBlog}
              />
            </div>
          )}
        </div>
      </WidgetWrapper>
    </BHBasePage>
  );
}

export async function loader() {
  const data = await fetchSeasonalTagData();
  const { gaData } = SeasonalTagsMetaData(adsSectionName);
  return {
    ...data,
    gtm: getGTMData(gaData),
  };
}
